// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".echo-ios-privacy_protocol[data-v-5657dd22] {\n  width: 100%;\n  height: 100vh;\n  overflow-y: hidden;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n}\n.echo-ios-privacy_protocol .page-container[data-v-5657dd22] {\n  box-sizing: border-box;\n  background-color: #ffffff;\n  padding: 0 15px;\n  flex: 1;\n}\n.echo-ios-privacy_protocol .page-container .iframe[data-v-5657dd22] {\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
